import { getLocalApi } from "./localApi";
import { Country } from "app/shared/model";
import apiConfig from "app/api/apiConfig.json";

export type CountryWithNumericId = Country & {
    numericId?: number;
};

function parsePositiveInt(v: unknown): number | undefined {
    if (v === undefined || v === null) return undefined;
    if (typeof v === 'number' && Number.isFinite(v) && v > 0) return v;
    if (typeof v === 'string') {
        const n = Number(v.trim());
        if (Number.isFinite(n) && n > 0) return n;
    }
    return undefined;
}

export async function getAllCountries() : Promise<CountryWithNumericId[]> {
    const localApi = await getLocalApi();

    return await localApi.fetchList(apiConfig.reference_data_get_countries, (dto:any) => {
        const numericId: number | undefined =
            parsePositiveInt(dto.countryId) ??
            parsePositiveInt(dto.CountryId) ??
            parsePositiveInt(dto.countryID) ??
            parsePositiveInt(dto.numericId) ??
            parsePositiveInt(dto.numericCountryId) ??
            parsePositiveInt(dto.id);

        return {
            name: dto.name,
            id: dto.id,
            numericId: numericId
        };
    }, 'Unable to fetch countries')
}